import { URLParser } from '../utils/URLParser';

export const searchParamEqualsValue = (searchParam, expectedValue) => {
  return (traffic) => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value === expectedValue;
  };
};
